import { render, staticRenderFns } from "./vpd-footer.vue?vue&type=template&id=3f5d0f6a"
import script from "./vpd-footer.vue?vue&type=script&lang=js"
export * from "./vpd-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports